export const testimonials = [
  {
    name: 'Patricia L.',
    role: 'Physical Therapist, 47 — Geriatric Outpatient Clinic',
    initials: 'PL',
    quote:
      'Most of my caseload is adults over 70 with balance problems and fear of falling. I used to piece sessions together from course notes and old handouts. Now I open the postural control or gait volume, pick the protocol, and positioning, guarding and dosage are already there. My 30-minute sessions finally have a clear structure from start to finish.',
  },
  {
    name: 'Robert H.',
    role: 'Physiotherapist, 52 — Home Health Rehabilitation',
    initials: 'RH',
    quote:
      "Treating in patients' homes means I can't carry a library with me. The chair-based protocols and the home exercise pack are what I use most. I prescribe seated trunk control and supported strengthening, print the weekly calendar, and the caregiver knows exactly what to do between visits.",
  },
  {
    name: 'Mariana S.',
    role: 'Physical Therapist, 38 — Skilled Nursing Facility',
    initials: 'MS',
    quote:
      'Sit-to-stand and transfers are daily goals for my residents. Volume 03 breaks down sit-to-stand retraining and controlled chair descent with sets, rest and corrective cues, so our whole team follows the same progression. The progress tracking templates made documentation much faster too.',
  },
  {
    name: 'Andrew K.',
    role: 'Physical Therapist, 44 — Neuro & Vestibular Rehab',
    initials: 'AK',
    quote:
      'The gait retraining volume was exactly what I was missing. Foot clearance, step-length symmetry, obstacle negotiation and external cueing are organized with clear progressions. I also appreciate that the reactive balance section stresses supervision and fall protection — it reads like it was written by clinicians.',
  },
  {
    name: 'Elena R.',
    role: 'Physiotherapist & Clinic Director, 55 — Falls Prevention Program',
    initials: 'ER',
    quote:
      'We run a falls prevention program with four therapists. The four- and six-week program templates gave us a shared framework, and the assessment toolkit keeps our reassessments consistent. New staff get up to speed much faster because every session is already mapped out.',
  },
]
